import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { LimitPriceInputProps } from './interface'

const defaultOptions = [
  {
    label: '允许使用限价',
    value: true
  },
  {
    label: '不允许使用限价',
    value: false
  }
]

const Component = ({
  disabled,
  value = {},
  allowNull = false,
  onChange
}: LimitPriceInputProps) => {
  const handleSelectChange = (allowLimitPrice: boolean) => {
    onChange?.({ ...value, allowLimitPrice })
  }

  const handleInputChange = (limitPrice: string | number | null) => {
    onChange?.({
      ...value,
      limitPrice: isNil(limitPrice)
        ? allowNull
          ? limitPrice
          : 0
        : Number(limitPrice)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={defaultOptions}
        value={value.allowLimitPrice}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled}
        min={0}
        style={{ width: '100%' }}
        value={value.limitPrice}
        onChange={handleInputChange}
      />
      <Space.Addon>元</Space.Addon>
    </Space.Compact>
  )
}

export const LimitPriceInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
